import jwtDecode from 'jwt-decode'
import { Socket } from 'socket.io-client'
import { State } from './state'
import {
    GetMembershipDetailsResponse,
    GetSubscriptionsResponse,
    MemberPaymentMethod,
} from '@/types/response/GetMembershipDetailsResponse'
import { Club } from '@/types/Club.type'
import { ClaimableNFT } from '@/types/nft/ClaimableNFT.type'

// @warning: You probably want to use this mutation passing by "setToken"
export const DECODE_TOKEN = (state: State, { token }: { token?: string | null }) => {
    try {
        state.token = token || null
        state.decodedToken = token ? jwtDecode(token) : null
    } catch (e) {
        state.decodedToken = null
    }
}

export const SET_WALLET_ADDRESS = (state: State, { address }: { address: string }) => {
    state.walletAddress = address
}

export const SET_NFT_LIST = (state: State, { nftList }: { nftList: ClaimableNFT[] }) => {
    state.nftList = nftList
}

export const SET_ME = (state: State, { me }: any) => {
    state.me = me
}

export const SET_ME_COMPLETED = (state: State) => {
    state.meCompleted = true
}

export const SET_MEMBERSHIP = (state: State, { membership }: { membership: GetMembershipDetailsResponse }) => {
    state.membership = membership
}

export const SET_SUBSCRIPTIONS = (state: State, { subscriptions }: { subscriptions: GetSubscriptionsResponse }) => {
    state.subscriptions = subscriptions
}

export const SET_LOADING = (state: State, payload: any) => {
    Object.assign(state.loading, payload)
}

export const REMOVE_CLUB_FROM_MEMBERSHIP = (state: State, { club }: { club: Club }) => {
    if (state.membership) {
        state.membership.clubs = state.membership.clubs.filter(c => c.id !== club.id)
    }
}

export const SET_FAVORITE_MEMBERSHIP_PAYMENT_METHOD = (state: State, paymentMethod: MemberPaymentMethod) => {
    if (state.membership?.subscription) {
        state.membership.subscription.favoritePaymentMethod = paymentMethod
    }
}

export const SET_SOCKET = (state: State, { socket }: { socket: Socket }) => {
    state.socket = socket
}

export const SET_SOCKET_ID = (state: State, { socketId }: { socketId: string }) => {
    state.socketId = socketId
}

export const SET_NETWORKING_TOKEN = (state: State, { token }: { token: string }) => {
    state.networkingToken = token
}
